import {
  LOU_CHEYMOL_URL,
  NOAN_PETRO_VERNEAU_URL,
  PAUL_LUNEAU_URL,
  THIBAULT_MALBRANCHE_URL,
  GEOFFREY_DORNE_URL,
} from "../remerciementsAssets";

type RemerciementLinkProps = {
  href: string;
  children: string;
};

function RemerciementLink({ href, children }: RemerciementLinkProps) {
  return (
    <a className="remerciements-link" href={href} rel="noopener noreferrer" target="_blank">
      {children}
    </a>
  );
}

export function RemerciementsSection() {
  return (
    <section className="section remerciements-section" id="remerciements">
      <div className="section-heading">
        <p className="kicker">Remerciements</p>
      </div>
      <p className="remerciements-copy">
        Toute bonne dictature doit remercier ses fidèles : <br /> <b></b>{" "}
        <RemerciementLink href={PAUL_LUNEAU_URL}>Paul LUNEAU</RemerciementLink> pour la mise en
        scène et la réécriture,
        <br />
        <RemerciementLink href={LOU_CHEYMOL_URL}>Lou CHEYMOL</RemerciementLink> {" "}
        pour l'affiche et les illustrations de la pièce, {" "}
        <br />
        <RemerciementLink href={NOAN_PETRO_VERNEAU_URL}>Noan PETRO VERNEAU</RemerciementLink> {" "}
        pour le dossier de presse, la stratégie de communication et le comité de censure,
        <br />
        <RemerciementLink href={THIBAULT_MALBRANCHE_URL}>Thibault MALBRANCHE</RemerciementLink> {" "}
        pour l'aide sur le site et son serveur, <br />
        <RemerciementLink href={GEOFFREY_DORNE_URL}>Geoffrey DORNE</RemerciementLink>, pour l’édition de notre magnifique livre. <br />
        Julie SIMON notre plus fidèle spectatrice,  <br />
        Ainsi que toutes les personnes qui sont venues nous voir jouer en répétition, qui ont relu notre texte, et qui nous aident à trouver des salles pour jouer notre spectacle. <br /> <br />
      </p>
    </section>
  );
}
